import { OnInit, Component, Optional, Inject } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { PcfService } from '../../../services/PcfService.component';
import { Subscription } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { NxiRestService } from '../../../services/NXI-Rest.service';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'Fixed-Income',
    templateUrl: './FixedIncomeCashFlowFilter.component.html',
    styleUrls: ['./FixedIncomeCashFlowFilter.component.css']
})
export class FixedIncomeCashFlowFilterComponent implements OnInit {
    showDiv: Boolean = false;
    data: any;
    summary: any = [];
    reportType= '2';
    maturityYear: any;
    loading: Boolean = true;
    down: any;
    ismobile: boolean = false;
    monthAbb = [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december'
    ];
    summaryKeys = Object.keys(this.summary);
    acctRef: any;
    activeSort: any;
    reverseSort: boolean;
    subs: Subscription;
    currYear: any;
    nextYear: any;
    serviceUrl: any;
    yearda: any;
    isAda: boolean = false;
    error: any;
    constructor(private contextService: IContextService, private pcfservice: PcfService, private nxiRestService: NxiRestService,
                private translationService: PershingTranslationService, @Optional() @Inject('AppSettings') appSettings: any) {
                this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
                if (appSettings.deviceType === 'mobile') {
                    this.ismobile = true;
                 }
                if (appSettings.themeType === 'ada') {
                    this.isAda = true;
                }
                }
    ngOnInit() {
        this.serviceUrl = this.nxiRestService.serviceUrl;
        this.maturityYear = new Date();
        this.maturityYear = this.maturityYear.getFullYear();
        this.loading = true;
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.acctRef = contextValue.hashValue;
            this.download();
            this.getYear();
            this.applyFilter(this.maturityYear);
        });
    }
    applyFilter(year) {
        this.maturityYear = year;
        const params = new HttpParams()
            .set('reportType', this.reportType)
            .set('maturityYear', year)
            .set('isGDR', 'true');
        this.pcfservice.FixedIncomecashflowfliter(this.serviceUrl, this.acctRef, params).subscribe(
            data => {
                this.data = data;
                if (this.data.fiCshFlwSummary !== null) {
                for (let i of this.data.fiCshFlwSummary){
                    for (let j = 0; j < 12; j++) {
                        if (this.summary.length < (j + 1)) {
                            this.summary.push({'showDiv': false, 'index': j});
                            this.summary[j]['key'] = [];
                        }
                        this.summary[j][i.bondType] = i[this.monthAbb[j].substr(0, 3) + 'FixedValue'];
                        this.summary[j].key.push(i.bondType);
                    }
                }} else {
                    this.summary = [];
                    for (let i = 0; i < 12; i++) {
                        let row = {};
                        row['showDiv'] = false;
                        row['index'] = i;
                        row['key'] = [];
                        row['TOTAL'] = '-';
                        this.summary.push(row);
                    }
                }
                this.loading = false;
            },
            err => {
                console.error(err);
                this.error = err;
            },
            () => console.log('data recieved')
        );
    }
    getYear() {
        this.currYear = null;
        this.nextYear = null;
        this.nxiRestService.getNxiPortfolioRestResponse(this.acctRef, 'fiCshFlw/summary?reportType=1&isGDR=true').subscribe(
            resp => {
                if (resp && resp.fiCshFlwSummary && resp.fiCshFlwSummary.length > 0) {
                    this.currYear = resp.fiCshFlwSummary[0].fundPaymentDate;
                    if (resp.fiCshFlwSummary.length > 1) {
                        this.nextYear = resp.fiCshFlwSummary[1].fundPaymentDate;
                    }
                }
            }
        );
    }
    sort(att) {
            if ( att === this.activeSort) {
              this.reverseSort = !this.reverseSort;
              if (!this.reverseSort) {
                this.summary.sort((a, b) => (a[att] > b[att]) ? 1 : -1);
              }else {
                this.summary.sort((a, b) => (a[att] < b[att]) ? 1 : -1);
              }
            }else {
              this.activeSort = att;
              this.reverseSort = false;
              this.summary.sort((a, b) => (a[att] > b[att]) ? 1 : -1);
            }
        }
    download() {
            this.down = (this.serviceUrl + '/portfolio/' + this.acctRef + '/fiCshFlw/summary/excel?reportType='
            + this.reportType + '&isGDR=true&localeParam=en_US&maturityYear=' + this.maturityYear);
    }
}
